module.exports = __webpack_public_path__ + "img/20200110160023360截图20200110110624255.1dda6b11.jpg";